

























import { defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "AvatarDescription",
  components: { BaseAvatar },
  props: {
    userPublicData: { type: Object as () => UserPublicData | UserWithAvatar, required: true },
    avatarSize: { type: Number, default: 56 },
    title: { type: String },
    description: { type: String },
    to: Object as () => Location,
    borderBottom: { type: Boolean, default: false },
    hideOnlineStatus: { type: Boolean, default: false },
    hideBroadcasting: { type: Boolean, default: false },
    showStoryCreateBtn: { type: Boolean, default: false },
    showStoryInfo: { type: Boolean, default: false },
  },
});
